import script from "./VersionChangesModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VersionChangesModal.vue?vue&type=script&setup=true&lang=js"

import "./VersionChangesModal.vue?vue&type=style&index=0&id=041b4acc&lang=css"

const __exports__ = script;

export default __exports__